export default __webpack_public_path__ + "static/media/pages-projects-list.0df4f217.jpg";